import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { userPasswordReset } from "../../store/auth/actions";
export var UseUserResetPassword = function (trigger, email) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responsePasswordReset: (_a = state.Login.responsePasswordReset) === null || _a === void 0 ? void 0 : _a.data,
            errorPasswordReset: state.Login.errorPasswordReset,
            loadingPasswordReset: state.Login.loadingPasswordReset,
        });
    }), responsePasswordReset = _a.responsePasswordReset, errorPasswordReset = _a.errorPasswordReset, loadingPasswordReset = _a.loadingPasswordReset;
    useEffect(function () {
        if (trigger) {
            dispatch(userPasswordReset(email));
        }
    }, [email, trigger]);
    return {
        responsePasswordReset: responsePasswordReset,
        errorPasswordReset: errorPasswordReset,
        loadingPasswordReset: loadingPasswordReset,
    };
};
